
import * as React from "react";
type videoBtn = [cameraButtonClick: boolean, setCameraButtonClick: (value: boolean) => void];
const VideoButtonContext = React.createContext<videoBtn>([false, () => ({})]);
export default VideoButtonContext;